module.exports = __webpack_public_path__ + "static/media/ArrowNextGray.b8a2b4e7.svg";